import styled from 'styled-components'
import { useFormContext } from 'react-hook-form'
import get from 'lodash/get'

import useFeatureFlag from 'hooks/useFeatureFlag'
import { petFees } from 'featureFlags'

import { ErrorLabel } from '../../../components/form'

import GuestsInput from '../../../components/hookForm/GuestsInput'
import BookingFormCalendar from '../../../components/enquiry/BookingFormCalendar'
import BookingTimeSlot from '../../../components/enquiry/BookingTimeSlot'

import ConditionalAvailabilityAlert from './AvailabilityAlert/ConditionalAvailabilityAlert'

const Wrapper = styled.div`
  .DateRangePicker,
  .SingleDatePicker {
    width: 100%;
  }
`

const validDate = (value) =>
  !value ? 'Please add dates to request a booking' : true
const validEnquiryDate = (value) =>
  !value ? 'Please add your preferred dates to make an enquiry' : true

const BookingFormFields = ({
  listingId,
  listing,
  enquiry,
  formValues,
  isEnquiryForm,
}) => {
  const {
    register,
    formState: { errors, isSubmitted },
  } = useFormContext()

  const petFeesEnabled = useFeatureFlag(petFees)
  const maxPets = listing && listing.pet_friendly ? listing.max_pets || 10 : 0

  const enquiryListing = get(enquiry, 'data.listing')

  let startDate
  let endDate

  if (enquiryListing && enquiry && enquiry.data) {
    const { start_date, end_date } = enquiryListing && enquiry && enquiry.data
    startDate = start_date
    endDate = end_date
  }

  const dateValidator = isEnquiryForm ? validEnquiryDate : validDate
  // Fall back to the end-date error so a half-picked range (start filled, end
  // still null) keeps the prompt visible — otherwise validating-on-pick would
  // make the form look error-free while the end_date validator is still failing.
  const datesError =
    get(errors, 'booking.start_date') || get(errors, 'booking.end_date')

  return (
    <Wrapper className="fields">
      <div className="field">
        <BookingFormCalendar
          listingId={listingId}
          start_date={startDate}
          end_date={endDate}
          snoozed={listing.booking_window === 0}
        />

        {datesError && isSubmitted && (
          <ErrorLabel htmlFor="booking[start_date]">
            {datesError.message}
          </ErrorLabel>
        )}

        <input
          type="hidden"
          {...register('booking[start_date]', { validate: dateValidator })}
        />

        <input
          type="hidden"
          {...register('booking[end_date]', { validate: dateValidator })}
        />
      </div>

      {enquiry && (
        <BookingTimeSlot time_slots={enquiry.data && enquiry.data.time_slots} />
      )}

      <GuestsInput
        capacity={(listing && listing.capacity) || 10}
        guests={
          formValues && formValues.booking.adults + formValues.booking.children
        }
        petsEnabled={petFeesEnabled}
        pets={(formValues && formValues.booking.pets) || 0}
        maxPets={maxPets}
        rounded
      />

      <ConditionalAvailabilityAlert
        endDate={endDate}
        availabilityScore={listing.availability_score}
        style={{ marginTop: '24px' }}
      />
    </Wrapper>
  )
}

export default BookingFormFields
